import { render } from "./TicketPayment.vue?vue&type=template&id=10082173&scoped=true"
import script from "./TicketPayment.vue?vue&type=script&lang=js"
export * from "./TicketPayment.vue?vue&type=script&lang=js"

import "./TicketPayment.vue?vue&type=style&index=0&id=10082173&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10082173"]])

export default __exports__